import Notifications from '@mui/icons-material/Notifications'
import styled from 'styled-components'

export const ThemeBasedNotificationIcon = styled(Notifications)`
  color: ${({ themeType }) => (themeType === 'dark' ? '#9ca3af' : '#6b7280')};
`
